module.exports = __webpack_public_path__ + "img/Mouseo_Kotsanas_en.99ec4a5e.jpg";